import {PostCorrectiveTaxDocumentForCreatingApiResponse} from '@dms/api/sales';

import {AccountingDocumentFormValues} from '../../../types';

export const mapCustomer = (
  id: string | undefined,
  data: NonNullable<PostCorrectiveTaxDocumentForCreatingApiResponse>['customerDetails'] | undefined
): Partial<AccountingDocumentFormValues['customer']> => ({
  id,
  addressLine1: data?.addressLine1,
  addressLine2: data?.addressLine2,
  city: data?.city,
  zip: data?.zip,
  country: data?.country,
  cin: data?.cin,
  tin: data?.tin,
  tradeName: data?.tradeName,
  name: data?.name,
});
